import { createApp } from 'vue';
import message from './index.vue';

const app = createApp(message);
const instance = app.mount(document.createElement('div'));
document.body.appendChild(instance.$el);

/**
 * show方法options对象所需参数
 * string类型的如果不需要可不填写
 * @param {Boolean} [image] - 是否展示成功图片
 * @param {String} [title] - 标题
 * @param {String} [desc] - 描述，想要使用desc，那么count必须为false
 *
 * @param {Object} [descGroup] - 描述组合
 * @param {String} [desc] - 描述头
 * @param {String} [desc2] - 描述头2
 * @param {Array} [subDesc] - 子描述
 *
 * @param {Boolean} [count] - 是否需要倒计时, 如果count为true，desc会直接不展示
 * @param {String} [countDescHead] - 倒计时描述头
 * @param {String} [currentCount] - 倒计时数值
 * @param {String} [unit] - 倒计时单位
 * @param {String} [countDescFooter] - 倒计时描述尾
 *
 * @param {String} [confirmBtn] - 确认按钮文本
 * @param {String} [cancelBtn] - 取消按钮文本
 * @param {Boolean} [closeIcon] - 是否需要右上角的关闭图标
 *
 * @param {String} [nextStep] - 将要跳转的地址
 * @param {Boolean} [justHide] - 只做关闭处理
 *
 * @param {Object} [descGroup] - 描述列表
 * @param {Function} [callback] - 回调函数
 */
const md = {
  getIssueApi: null,
  issueApi(fn) {
    this.getIssueApi = fn;
  },
  show(
    options = {
      image: true,
      title: 'Complete',
      desc: 'Your password has been reset successfully.',
      desc2: '',
      i18nNeed: true,
      sucImgSrc: '',
      countDescHead: '',
      count: false,
      currentCount: '',
      unit: '',
      countDescFooter: '',

      confirmBtn: 'Log In',
      cancelBtn: '',
      closeIcon: false,
      justHide: false,
      nextStep: '/',
      descGroup: {
        desc1: '',
        desc2: '',
        subDesc: [],
      },
      callback: '',
    },
  ) {
    instance.show(options);
    // const that = instance
  },

  hide() {
    instance.hide();
  },
};

export default md;

// 弹窗Demo
// 成功信息
// this.$messageModal.show({
//   image: true,
//   title: this.$i18n.t('complete'),
//   desc: this.$i18n.t('passwordSf'),
//   confirmBtn: this.$i18n.t('login'),
//   nextStep: '/'
// });

// 计划已改变信息
// this.$messageModal.show({
//   image: false,
//   desc: this.$i18n.t('membershipDt'),
//   confirmBtn: this.$i18n.t('viewMemb'),
//   cancelBtn: this.$i18n.t('cancel'),
//   nextStep: '/'
// });

// Visa卡不符合此计划的资格
// this.$messageModal.show({
//   image: false,
//   closeIcon: true,
//   desc: this.$i18n.t('notEligible'),
//   confirmBtn: this.$i18n.t('ok'),
//   cancelBtn: this.$i18n.t('cancel'),
//   nextStep: '/'
// });

// 15分钟会话已经过期
// this.$messageModal.show({
//   image: false,
//   title: this.$i18n.t('sessionTime'),
//   closeIcon: true,
//   countDescHead: this.$i18n.t('your'),
//   currentCount: '15',
//   unit: this.$i18n.t('unit'),
//   countDescFooter: this.$i18n.t('expired'),
//   confirmBtn: this.$i18n.t('login'),
//   cancelBtn: this.$i18n.t('cancel'),
//   nextStep: '/'
// });

// Visa卡不符合此计划的资格
// this.$messageModal.show({
//   image: false,
//   title: this.$i18n.t('sessionTime'),
//   closeIcon: true,
//   countDescHead: this.$i18n.t('your'),
//   currentCount: '15',
//   unit: this.$i18n.t('unit'),
//   countDescFooter: this.$i18n.t('expired'),
//   confirmBtn: this.$i18n.t('login'),
//   cancelBtn: this.$i18n.t('cancel'),
//   nextStep: '/'
// });

// Ingenico卡校验失败弹窗
// this.$messageModal.show({
//   image: false,
//   confirmBtn: this.$i18n.t('ok'),
//   descGroup: {
//     desc1: this.$i18n.t('mayHave'),
//     desc2: this.$i18n.t('reEntering'),
//     subDesc: [
//       this.$i18n.t('have1'),
//       this.$i18n.t('have2'),
//       this.$i18n.t('have3'),
//     ],
//   },
//   nextStep: '/'
// });
